import { forwardRef, memo } from "react";
import { Modal } from "semantic-ui-react";

// Styles
import "./MeHeyLanding.scss";

// Components
import LandingContainer from "./LandingContainer";
import LoginForm from "./LoginForm";
import EmailRegisterForm from "./EmailRegisterForm";
import EmailVerificationForm from "./EmailVerificationForm";

type MeHeyLandingLoginModProps = {
  open: boolean;
  onClose: () => void;
  currentView: ViewType;

  // login
  AppInitializeSequence: any;
  setProp: (key: string, value: any, callback?: () => void) => any;
  controller?: any;
  facebookLogin?: (name: string) => void;
  loadingLogin?: boolean;
  // onEmailRegister={handleEmailRegister}
  // onEmailSuccess={handleEmailSuccess}
  onLoginLoading?: (loading: boolean) => void;
  onLoginSubmit: () => void;
  onLoginSuccess: (res: any) => void;

  // register
  email: string;
  onRegisterSuccess: (message: string) => void;
};

type ViewType = "fb-loading" | "login" | "register" | "verification";

const MeHeyLandingLoginMod = memo(
  forwardRef<any, MeHeyLandingLoginModProps>((props, ref) => {
    return (
      <Modal
        className={props.open ? "fade-in" : "fade-out"}
        ref={ref}
        open={props.open}
        onClose={props.onClose}
        style={{ width: "max-content" }}
      >
        <div style={{ width: "36rem", margin: "2rem" }}>
          {props.currentView === "login" && (
            <LandingContainer isMeHey>
              <LoginForm
                isMeHey
                setProp={props.setProp}
                controller={props.controller}
                AppInitializeSequence={props.AppInitializeSequence}
                facebookLogin={props.facebookLogin}
                loadingLogin={props.loadingLogin}
                // onEmailRegister={handleEmailRegister}
                // onEmailSuccess={handleEmailSuccess}
                onLoginLoading={props.onLoginLoading}
                onLoginSubmit={props.onLoginSubmit}
                onLoginSuccess={props.onLoginSuccess}
              />
            </LandingContainer>
          )}

          {props.currentView === "register" && (
            <LandingContainer
              subtitle="Email"
              subtitleStyle={{ color: "" }}
              title="สร้างบัญชีใหม่ด้วย"
            >
              <EmailRegisterForm email={props.email} onSuccess={props.onRegisterSuccess} />
            </LandingContainer>
          )}

          {props.currentView === "verification" && (
            <LandingContainer subtitle="Email" subtitleStyle={{ color: "" }} title="ยืนยัน">
              <EmailVerificationForm email={props.email} onSuccess={props.onLoginSuccess} />
            </LandingContainer>
          )}
        </div>
      </Modal>
    );
  })
);

export default MeHeyLandingLoginMod;
